import React, { useContext } from "react"

import {
    AiOutlineLink,
    AiOutlineBarChart,
    
    } from "react-icons/ai"
import {SiWheniwork} from 'react-icons/si'
import {RiUserStarLine,RiUserSharedLine,RiUserAddLine} from 'react-icons/ri'
import {BsGrid1X2} from 'react-icons/bs';
import {HiOutlineDocumentDownload} from 'react-icons/hi'
import styles from './leftbar.module.css'
import { useHistory, NavLink } from "react-router-dom";

import { NavIconContext } from "../../../context/NavIconContext"

const IconList=()=>{

const {iconState,setIconState}=useContext(NavIconContext);
const purple = {color:"#7124BD"}

const history =useHistory();

const handleiconclick=(iconname)=>{
    history.push("/");
    setIconState(iconname)
}

    return(
        <> 
        {/*<div className={styles.Pic}>
            854
        <div>following</div>
    </div>*/}
 {/* <div  style={iconState==="newfeed"?purple:{}}  className={styles.Pic}>
        <BiNews onClick={()=>setIconState("newfeed")}/>
        <div>Newfeed</div>
        </div> */}
            <div className={styles.Pic}>
        <NavLink className={styles.links} to="/profile/tp0078">    
        <BsGrid1X2/>
        <div>Posts</div>
        </NavLink>
        </div>
        
        <div 
        style={iconState==="followingList"?purple:{}} onClick={()=>handleiconclick("followingList")} 
        className={styles.Pic}>
        <RiUserSharedLine/>
        <div>Following</div>
        </div>

        <div    className={styles.Pic}>
        <NavLink className={styles.links} to="/profile/tp0078/vlinks"> 
        <AiOutlineLink />
        <div>VLinks</div>
        </NavLink>
        </div>

        <div   className={styles.Pic}>
        < RiUserStarLine/>
        <div>Challenges</div>
        </div>

       

       

       

        <div className={styles.Pic}>
        <RiUserAddLine/>
        <div>Tags</div>
        </div>

        <div onClick={()=>handleiconclick("stats")} style={iconState==="stats"?purple:{}} className={styles.Pic}>
        <AiOutlineBarChart onClick={()=>handleiconclick("stats")}/>
        <div>Stats</div>
        </div>
        
        <div className={styles.Pic}>
        <HiOutlineDocumentDownload
         style={iconState==="mysaves"?purple:{}} onClick={()=>handleiconclick("mysaves")}
        />
        <div>Save</div>
        </div>

        {/* <div className={styles.Pic}>
        <AiOutlineFileText/>
        <div>Blogs</div>
        </div> */}

       

               <div className={styles.Pic}>
        <SiWheniwork  style={iconState==="activity"?purple:{}} onClick={()=>handleiconclick("activity")}  />
        <div>Activities</div>
        </div>

        {/* <div className={styles.Pic}>
        <RiPagesLine/>
        <div>Pages</div>
        </div> */}

        
         </>
    )
}

export default  IconList